export const PaymentMethods = Object.freeze({
  // These enum values map to values from OHI
  BANK_ACCOUNT: 'B',
  CREDIT_CARD: 'C',
  INVOICE: 'I',
});

export default PaymentMethods;
